<template>
  <a :href="href" :target="isExternalLink(href) ? '_blank' : null"
     download
     class="btn-base btn-red-custom link text-center text-uppercase text-white border-0" v-if="download">
    <span>{{ text }}</span>
  </a>
  <a :href="`tel:${phone}`"
     class="btn-base btn-red-custom link text-center text-uppercase text-white border-0"
     v-else-if="phone">
    <span>{{ text }}</span>
  </a>
  <a :href="href"
     :target="isExternalLink(href) ? '_blank' : null"
     class="btn-base btn-red-custom link text-center text-uppercase text-white border-0"
     v-else-if="hyperlink">
    <span>{{ text }}</span>
  </a>
  <button :type="[type ? 'submit' : 'button']"
          class="btn-base btn-red-custom text-center text-uppercase text-white border-0"
          v-else>
    <span v-if="loading"
          class="spinner-border spinner-border-sm me-1"
          role="status"
          aria-hidden="true">
    </span>
    <span>{{ text }}</span>
  </button>
</template>

<script>
import {isExternalLink} from "@/utils/utils";

export default {
  props: {
    loading: Boolean,
    hyperlink: Boolean,
    download: Boolean,
    text: {
      type: String,
      required: false
    },
    href: String,
    phone: String,
    type: String
  },
  data() {
    return {
      isExternalLink
    }
  }
}
</script>

<style scoped>

</style>
